import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=7788e348&scoped=true"
import script from "./AccountDialog.vue?vue&type=script&lang=js"
export * from "./AccountDialog.vue?vue&type=script&lang=js"
import style0 from "./AccountDialog.vue?vue&type=style&index=0&id=7788e348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788e348",
  null
  
)

export default component.exports